<form [formGroup]="staffCodeForm" (ngSubmit)="onSubmit()">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-title">{{ title }}</h4>
    <button
      type="button"
      class="close"
      aria-label="Close button"
      aria-describedby="modal-title"
      (click)="modal.dismiss()"
    >
      <span class="fas fa-times"></span>
    </button>
  </div>
  <div class="modal-body">
    <div class="onboarding-content form-group">
      <label for="staff" class="block font-medium mb-2">{{ 'staffCode.staff' | translate }}</label>

      <input
        type="text"
        id="staff"
        formControlName="staffCode"
        placeholder="{{ 'staffCode.enterStaffCode' | translate }}"
        class="form-control border rounded-md w-full p-2"
      />

      <!-- API validation -->
      <div *ngIf="isInvalidCode" class="text-danger text-sm mt-1">
        {{ 'staffCode.invalideCode' | translate }}
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">
      {{ 'staffCode.cancel' | translate }}
    </button>
    <button type="submit" class="btn btn-primary" [disabled]="loading">
      {{ loading ? ('staffCode.checking' | translate) : ('staffCode.submit' | translate) }}
    </button>
  </div>
</form>
